import NetworkApi from './networkApi';
import paths from './path';

export const getCurrentUserProfile = async () => {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
  };

  if (!token) {
    return false;
  }

  const data = await NetworkApi.get(paths.currentUser, headers).then((res) => res);

  return data;
};

export const forgotPassword = async (body) => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.post(paths.forgotPasswordUrl, body, headers);

  return data;
};

export const getAllUsersWithSearch = async (search, excludeSelf) => {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
  };

  const url = `${paths.getAllUsersWithSearch(search, excludeSelf)}`;
  const { data } = await NetworkApi.get(url, headers).then((res) => res);

  return data;
};
